import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginModalPage } from './login-modal';
import { TranslateModule } from '@ngx-translate/core';
import { BaselineSharedModule } from 'baseline-lib';


@NgModule({
  declarations: [
    LoginModalPage,
  ],
  imports: [
    TranslateModule,
    BaselineSharedModule,
    IonicPageModule.forChild(LoginModalPage),
  ],
  exports: [
    LoginModalPage
  ]
})
export class LoginModalPageModule {}



// WEBPACK FOOTER //
// ./src/app/shared/login-modal/login-modal.module.ts